<template>
  <div>
    <ModeSwitcher />
    <VitePwaManifest />

    <!-- Fixed navigation with app-like behavior -->
    <div class="nav-wrapper">
      <UserBackToHome />
    </div>

    <UDashboardLayout class="safe-area-top">
      <UDashboardPage>
        <UDashboardPanel grow>
          <UDashboardPanelContent class="px-0">
            <!-- Content area that can scroll when allowed -->
            <div class="app-user-page-container">
              <div :class="['app-user-page', { 'allow-scroll': allowScroll }]">
                <slot />
              </div>
            </div>
          </UDashboardPanelContent>
        </UDashboardPanel>
      </UDashboardPage>
    </UDashboardLayout>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useColorMode } from '@vueuse/core'
import ModeSwitcher from '~/components/ModeSwitcher.vue'

const route = useRoute()
const colorMode = useColorMode()

const allowScroll = computed(() => route.meta.allowScroll)

onMounted(() => {
  colorMode.value = 'dark'
})
</script>

<style>
@import '../assets/css/app-user.css';

.safe-area-top {
  padding-top: env(safe-area-inset-top);
}

/* Override any scrolling on the outer container */
.u-dashboard-panel-content {
  overflow: hidden !important;
}

/* Navigation wrapper */
.nav-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding-top: calc(env(safe-area-inset-top) + 0.75rem);
  -webkit-tap-highlight-color: transparent;
  touch-action: none !important;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  pointer-events: none;
}

.nav-wrapper>* {
  pointer-events: auto;
}
</style>
